(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grid-v7"] && !Shopify.designMode) return;
  try {
    
(function(){
  const sec  = document.getElementById('up-grid-{{ section.id }}');
  if(!sec) return;
  const grid = sec.querySelector('.ug-grid'); if(!grid) return;

  const css  = getComputedStyle(grid);
  const mqlT = window.matchMedia('(max-width: 989px)'); // tablet & below
  const mqlM = window.matchMedia('(max-width: 749px)');
  const wantsCarousel = sec.getAttribute('data-carousel') === 'true';
  const showAll       = sec.getAttribute('data-show-all') === 'true';

  const n = v => parseInt(String(v).trim(),10) || 0;
  const cols = () => mqlM.matches ? n(css.getPropertyValue('--cols-m'))
                     : (mqlT.matches ? n(css.getPropertyValue('--cols-t'))
                     : n(css.getPropertyValue('--cols-d')));
  const rows = () => mqlM.matches ? n(css.getPropertyValue('--rows-m'))
                     : n(css.getPropertyValue('--rows-d'));
  const cards = () => Array.prototype.filter.call(
    grid.children,
    el => el && el.nodeType === 1 && el.classList.contains('ug-card')
  );

  function centerLastRow(){
    // Clear any prior manual placements
    cards().forEach(el => { el.style.gridColumn = ''; });

    // Desktop only & not when carousel is active
    if (mqlT.matches || grid.classList.contains('is-carousel')) return;

    const C = Math.max(1, cols());
    const list = cards().filter(el => !el.hidden && el.style.display !== 'none');
    const count = list.length;
    if (!count) return;

    const r = count % C; // leftovers on last row
    if (r === 0) return;

    const startIndex = count - r;

    let colIndices = [];
    if (r === 1){
      // Single card → center column
      colIndices = [ Math.ceil(C/2) ];
    } else if (r === 2){
      // Two cards → perfect center
      if (C % 2 === 0){
        const left = C/2;
        colIndices = [ left, left+1 ];
      } else {
        const mid = (C + 1) / 2;
        colIndices = [ mid-1, mid+1 ];
      }
    } else {
      // 3..C-1 leftovers → center contiguous block
      const startCol = Math.ceil((C - r) / 2) + 1;
      for (let i = 0; i < r; i++) colIndices.push(startCol + i);
    }

    colIndices.forEach((col, i) => {
      const el = list[startIndex + i];
      if (el) el.style.gridColumn = String(col);
    });
  }

  function limitRows(){
    const limit = (showAll || grid.classList.contains('is-carousel')) ? Infinity : Math.max(1, cols()*rows());
    cards().forEach((el,i)=>{ el.hidden = i >= limit; el.style.display = el.hidden ? 'none' : ''; });
  }

  function setCarousel(){
    if (wantsCarousel && mqlT.matches) grid.classList.add('is-carousel');
    else grid.classList.remove('is-carousel');
  }

  function update(){
    setCarousel();
    limitRows();
    centerLastRow();
  }

  update();
  requestAnimationFrame(update);
  window.addEventListener('load', update);
  (mqlT.addEventListener ? mqlT.addEventListener('change', update) : mqlT.addListener(update));
  (mqlM.addEventListener ? mqlM.addEventListener('change', update) : mqlM.addListener(update));
  window.addEventListener('resize', update, { passive:true });

  // Keep in sync with theme editor / dynamic changes
  const mo = new MutationObserver(update);
  mo.observe(grid, { childList:true, subtree:false, attributes:true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-comparison"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('remedi-comparison-v5')){
  customElements.define('remedi-comparison-v5',class extends HTMLElement{
    connectedCallback(){
      queueMicrotask(()=>{if(this.isConnected)this.initialize();});
    }
    initialize(){
      if(this._events||!this.querySelector('.ra-scroll'))return;
      this._events=new AbortController();
      const signal=this._events.signal;
      this.querySelectorAll('.ra-select').forEach(select=>select.addEventListener('change',()=>this.updateVariant(select),{signal}));
      this.querySelectorAll('.ra-form').forEach(form=>form.addEventListener('submit',event=>this.addToCart(event,form),{signal}));
      this.addEventListener('click',event=>{
        if(this.dataset.designMode==='true'&&event.target.closest('a')){
          event.preventDefault();event.stopPropagation();this.previewMessage('Product links stay on this page in the theme editor. Test them in the storefront preview.');
        }
        const button=event.target.closest('.ra-read-more');
        if(button){const value=button.previousElementSibling;const open=!value.hasAttribute('data-expanded');value.toggleAttribute('data-expanded',open);button.setAttribute('aria-expanded',String(open));button.firstChild.textContent=open?'Read less':'Read more';}
      },{signal,capture:true});
      this.initializeResponsive(signal);
      this.scrollArea=this.querySelector('.ra-scroll');
      this.scrollNav=this.querySelector('.ra-scroll-nav');
      this.scrollArea?.addEventListener('scroll',()=>this.updateScrollArrows(),{signal,passive:true});
      this.querySelector('.ra-scroll-prev')?.addEventListener('click',()=>this.scrollFormats(-1),{signal});
      this.querySelector('.ra-scroll-next')?.addEventListener('click',()=>this.scrollFormats(1),{signal});
      const dialog=this.querySelector('.ra-drawer');
      this.querySelector('.ra-drawer-close')?.addEventListener('click',()=>dialog.close(),{signal});
      dialog?.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}},{signal});
      document.fonts?.ready.then(()=>{if(this.isConnected)this.measure?.();});
      this._blockSelect=event=>{if(!this.contains(event.target))return;event.target.querySelectorAll?.('.ra-value[data-collapsible]').forEach(value=>{value.setAttribute('data-expanded','');const button=value.nextElementSibling;if(button){button.setAttribute('aria-expanded','true');button.firstChild.textContent='Read less';}});const column=event.target.closest('[data-column-index]');if(column){this.first=Number(column.dataset.columnIndex);this.primary.value=String(this.first);if(this.first===this.second&&this.columnCount>1){this.second=(this.first+1)%this.columnCount;this.secondary.value=String(this.second);}this.renderColumns();}event.target.scrollIntoView?.({block:'nearest',inline:'nearest'});};
      document.addEventListener('shopify:block:select',this._blockSelect,{signal});
      this.querySelectorAll('.ra-select').forEach(select=>this.updateVariant(select));
    }
    disconnectedCallback(){if(this._events)this._events.abort();if(this.resizeObserver)this.resizeObserver.disconnect();this._events=null;}
    initializeResponsive(signal){
      this.primary=this.querySelector('.ra-primary-column');
      this.secondary=this.querySelector('.ra-secondary-column');
      this.tools=this.querySelector('.ra-responsive-tools');
      this.allButton=this.querySelector('.ra-all-toggle');
      this.columnNodes=Array.from(this.querySelectorAll('[data-column-index]'));
      this.columnCount=this.querySelectorAll('thead [data-column-index]').length;
      if(!this.columnCount)return;
      this.first=Number(this.primary?.value||0);
      this.second=this.columnCount>1?Number(this.secondary?.value||1):0;
      this.showAll=false;
      this.stateKey='remedi-comparison:'+location.pathname+':'+this.dataset.sectionId;
      if(this.dataset.designMode==='true'){try{const saved=JSON.parse(sessionStorage.getItem(this.stateKey)||'null');if(saved){this.first=Math.min(saved.first||0,this.columnCount-1);this.second=Math.min(saved.second||1,this.columnCount-1);if(this.first===this.second&&this.columnCount>1)this.second=(this.first+1)%this.columnCount;this.showAll=!!saved.showAll;this.primary.value=String(this.first);this.secondary.value=String(this.second);}}catch(error){}}
      this.primary.addEventListener('change',()=>{
        const previous=this.first;this.first=Number(this.primary.value);
        if(this.first===this.second){this.second=previous;this.secondary.value=String(previous);}
        this.renderColumns();
      },{signal});
      this.secondary.addEventListener('change',()=>{
        const previous=this.second;this.second=Number(this.secondary.value);
        if(this.second===this.first){this.first=previous;this.primary.value=String(previous);}
        this.renderColumns();
      },{signal});
      this.allButton.addEventListener('click',()=>{this.showAll=!this.showAll;this.renderColumns();},{signal});
      this.measure=()=>{
        const width=this.querySelector('.ra-inner').getBoundingClientRect().width;
        this.style.setProperty('--ra-visible-width',this.querySelector('.ra-scroll').clientWidth+'px');
        const labelWidth=parseFloat(getComputedStyle(this).getPropertyValue('--ra-label-width'))||180;
        const colWidth=parseFloat(getComputedStyle(this).getPropertyValue('--ra-col-min'))||240;
        this.dataset.layout=width>=labelWidth+this.columnCount*colWidth?'full':width>=560&&this.columnCount>1?'pair':'single';
        this.renderColumns();
      };
      if(window.ResizeObserver){this.resizeObserver=new ResizeObserver(this.measure);this.resizeObserver.observe(this.querySelector('.ra-inner'));}
      else{window.addEventListener('resize',this.measure,{signal});}
      this.measure();
    }
    renderColumns(){
      const full=this.dataset.layout==='full'||this.showAll;
      const visible=full?Array.from({length:this.columnCount},(_,i)=>i):this.dataset.layout==='pair'?[this.first,this.second]:[this.first];
      this.dataset.all=String(full);
      this.tools.hidden=this.dataset.layout==='full';
      this.querySelector('.ra-secondary-picker').hidden=this.columnCount<2;
      this.allButton.setAttribute('aria-pressed',String(this.showAll));
      this.allButton.textContent=this.showAll?'Return to focused view':'View all formats';
      this.columnNodes.forEach(node=>{
        const hide=!visible.includes(Number(node.dataset.columnIndex));
        if(hide&&node.contains(document.activeElement))this.primary.focus();
        node.toggleAttribute('data-column-hidden',hide);
      });
      this.querySelectorAll('.ra-shared-row td').forEach(cell=>cell.colSpan=visible.length+1);
      ['.ra-product-heading','.ra-zone'].forEach(selector=>{const items=Array.from(this.querySelectorAll(selector)).filter(node=>!node.closest('[data-column-hidden]'));items.forEach(node=>node.style.minHeight='0');const height=Math.ceil(Math.max(0,...items.map(node=>node.getBoundingClientRect().height)));items.forEach(node=>node.style.minHeight=height+'px');});
      this.updateScrollArrows();
      this.measureText();
      if(this.dataset.designMode==='true'){try{sessionStorage.setItem(this.stateKey,JSON.stringify({first:this.first,second:this.second,showAll:this.showAll}));}catch(error){}}
    }
    measureText(){
      this.querySelectorAll('.ra-value[data-collapsible]').forEach(value=>{
        if(value.closest('[data-column-hidden]'))return;
        const expanded=value.hasAttribute('data-expanded');value.removeAttribute('data-expanded');
        const truncated=value.scrollHeight>value.clientHeight+1;
        value.toggleAttribute('data-expanded',expanded);value.nextElementSibling.hidden=!truncated;
      });
    }
    previewMessage(text){const feedback=this.querySelector('.ra-feedback');feedback.hidden=false;feedback.querySelector('.ra-message').textContent=text;}

    updateVariant(select){
      const form=select.closest('form'),cell=form.closest('td'),option=select.options[select.selectedIndex];
      const button=form.querySelector('button[type="submit"]');
      if(button){button.disabled=!option||!option.value||option.dataset.available!=='true';button.querySelector('.ra-buy-label').textContent=button.disabled?this.dataset.soldLabel:this.dataset.addLabel;}
      const price=cell.querySelector('.ra-price');if(price&&option)price.textContent=option.dataset.price||'';
      const thumb=cell.querySelector('.ra-product-thumb');if(thumb&&option?.dataset.image){thumb.removeAttribute('srcset');thumb.removeAttribute('sizes');thumb.src=option.dataset.image;}
      const detail=cell.querySelector('.ra-connected-variant');if(detail&&option)detail.textContent=option.dataset.title==='Default Title'?'':option.dataset.title;
      if(option?.value){const url=new URL(form.dataset.viewBase,location.origin);url.searchParams.set('variant',option.value);cell.querySelectorAll('[data-connected-link]').forEach(link=>link.href=url.href);}
      const link=cell.querySelector('[data-product-link]');if(link&&option&&option.value){const url=new URL(form.dataset.viewBase,location.origin);url.searchParams.set('variant',option.value);link.href=url.href;}
    }
    updateScrollArrows(){
      const area=this.querySelector('.ra-scroll'),nav=this.querySelector('.ra-scroll-nav');if(!area||!nav)return;
      const overflow=area.scrollWidth>area.clientWidth+2;nav.hidden=!(this.dataset.all==='true'&&overflow);
      const position=Math.abs(area.scrollLeft);nav.querySelector('.ra-scroll-prev').disabled=position<2;nav.querySelector('.ra-scroll-next').disabled=position>=area.scrollWidth-area.clientWidth-2;
    }
    scrollFormats(direction){const area=this.querySelector('.ra-scroll');const cell=this.querySelector('thead [data-column-index]:not([data-column-hidden])');const rtl=getComputedStyle(area).direction==='rtl';area.scrollBy({left:direction*(rtl?-1:1)*(cell?.getBoundingClientRect().width||area.clientWidth*.7),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
    async animateProduct(form){
      if(this.dataset.animateCart!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      const index=form.closest('[data-column-index]')?.dataset.columnIndex;
      const image=this.querySelector('thead [data-column-index="'+index+'"] .ra-image');
      const target=document.querySelector('#cart-icon-bubble, [data-cart-toggle], a[href$="/cart"]')||this.querySelector('.ra-drawer-close');
      if(!image||!target)return;const from=image.getBoundingClientRect(),to=target.getBoundingClientRect();if(!from.width||!to.width)return;
      const clone=image.cloneNode();clone.removeAttribute('id');clone.alt='';clone.setAttribute('aria-hidden','true');Object.assign(clone.style,{position:'fixed',left:from.left+'px',top:from.top+'px',width:from.width+'px',height:from.height+'px',zIndex:'2147483647',pointerEvents:'none',borderRadius:'10px'});document.body.append(clone);
      try{await clone.animate([{transform:'translate(0,0) scale(1)',opacity:.85},{transform:'translate('+(to.left+to.width/2-from.left-from.width/2)+'px,'+(to.top+to.height/2-from.top-from.height/2)+'px) scale(.1)',opacity:0}],{duration:450,easing:'cubic-bezier(.25,.7,.2,1)'}).finished;}finally{clone.remove();}
    }
    async openFallbackCart(root){
      const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});if(!response.ok)throw Error('Item added. Use View cart to review your cart.');const cart=await response.json();
      const dialog=this.querySelector('.ra-drawer'),container=dialog.querySelector('.ra-drawer-items');container.replaceChildren();
      const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cart.currency||'USD'}).format(value/100);
      for(const item of cart.items){const row=document.createElement('div');row.className='ra-drawer-item';if(item.image){const image=document.createElement('img');image.src=item.image;image.alt=item.product_title;image.width=72;image.height=72;row.append(image);}const content=document.createElement('div');const name=document.createElement('p');name.textContent=item.product_title;const detail=document.createElement('p');detail.textContent=(item.variant_title?item.variant_title+' · ':'')+'Quantity: '+item.quantity+' · '+money(item.final_line_price);content.append(name,detail);row.append(content);container.append(row);}
      dialog.querySelector('.ra-drawer-total').textContent='Subtotal: '+money(cart.total_price);if(!dialog.open)dialog.showModal();
    }
    async addToCart(event,form){
      event.preventDefault();event.stopPropagation();if(this.dataset.designMode==='true'){this.previewMessage('Cart actions are paused in the theme editor. Test Add to cart in the storefront preview.');return;}const button=form.querySelector('button[type="submit"]');if(!button||button.disabled||this._adding)return;
      const variantId=new FormData(form).get('id');if(!variantId)return;this._adding=true;
      const controls=Array.from(this.querySelectorAll('.ra-form button[type="submit"],.ra-select'));const previous=controls.map(node=>node.disabled);controls.forEach(node=>node.disabled=true);
      const label=button.querySelector('.ra-buy-label'),original=label.textContent;label.textContent=this.dataset.loadingLabel;button.setAttribute('aria-busy','true');
      const feedback=this.querySelector('.ra-feedback'),message=this.querySelector('.ra-message'),cartLink=this.querySelector('.ra-cart-link');feedback.hidden=false;cartLink.hidden=true;message.textContent='';
      let added=false;
      try{
        const root=window.Shopify?.routes?.root||'/';
        const drawer=document.querySelector('cart-drawer');let sections=[];
        if(drawer&&typeof drawer.renderContents==='function'&&typeof drawer.getSectionsToRender==='function'){sections=drawer.getSectionsToRender().map(item=>item.id).slice(0,5);drawer.setActiveElement?.(button);}
        const payload={items:[{id:variantId,quantity:1}]};if(sections.length){payload.sections=sections;payload.sections_url=location.pathname;}
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});const result=await response.json();
        if(!response.ok)throw Error(typeof result.description==='string'?result.description:typeof result.message==='string'?result.message:this.dataset.errorLabel);
        added=true;message.textContent=form.dataset.productTitle+' — '+this.dataset.successLabel;cartLink.hidden=false;
        this.dispatchEvent(new CustomEvent('remedi:cart:add',{bubbles:true,detail:{items:result.items,variantId,sections:result.sections}}));
        if(this.dataset.cartBehavior!=='stay'){
          await this.animateProduct(form).catch(()=>{});
          let handled=false;
          if(sections.length&&result.sections&&sections.every(id=>typeof result.sections[id]==='string')){try{drawer.classList.remove('is-empty');drawer.renderContents(result);handled=true;}catch(error){handled=false;}}
          if(!handled)await this.openFallbackCart(root);
        }
      }catch(error){message.textContent=(added?'Item added to cart. ':'')+(error.message||this.dataset.errorLabel);if(added)cartLink.hidden=false;}
      finally{label.textContent=original;button.removeAttribute('aria-busy');controls.forEach((node,index)=>node.disabled=previous[index]);this._adding=false;}
    }

  });
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('remedi-comparison-v5').forEach(chart=>chart.initialize()));
}

  } catch(e) { console.error(e); }
})();
})();
